import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';

export const InternalContainer = styled(Link)`
  text-decoration: underline;
`;